import React, {Component, Fragment} from 'react';
import styled from 'styled-components';
import {colors, typography} from '@atlaskit/theme';
import {LadaLogoIcon} from '../../components/Icons';
import Button, {ButtonGroup} from '@atlaskit/button';
import {FormFooter} from '@atlaskit/form';
import {connect} from 'react-redux';
import AuthActions from '../../redux/AuthRedux';
import MessagesActions from '../../redux/MessagesRedux';
import LanguageActions from '../../redux/LanguageRedux';
import {TextField} from '../../components/FormFields';
import {preparePhoneNumber} from '../../helpers/string';
import {withTranslation, Trans} from 'react-i18next';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 90vh;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LangsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LadaTitle = styled.span`
  ${typography.h400}
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 28px;
  letter-spacing: 0.3px;
  color: ${colors.N500};
  display: block;
  margin: 0px;
`;

const PortalTitle = styled.span`
  ${typography.h600}
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0.3px;
  color: ${colors.N500};
  margin: 0px;
`;

const StyledForm = styled.form`
  width: 300px;
`;

const TimeMsg = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: -0.1px;
  color: #6B778C;
  margin-top: 12px;
`;

const BLOCK_REQUEST_PWD_TIME = 30*1000;

class LoginPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startTime: null,
      time: null,
      phone: '',
      password: '',
    };
    this.timer = null;
  }

  onFormSubmit = e => {
    e.preventDefault();
    const {password} = this.state;
    const phone = preparePhoneNumber(this.state.phone); 
    if (phone) {
      this.props.login(phone, password);
    } else {
      this.showPhoneError();
    }
  }

  onRememberPassowrd = e => {
    e.preventDefault();
    const phone = preparePhoneNumber(this.state.phone);
    if (phone) {
      this.setState({startTime: Date.now()}, () => {
        this.props.remember(phone);
      });
    } else {
      this.showPhoneError();
    }
  }
  showPhoneError = () => {
    const {showPhoneError, t} = this.props;
    showPhoneError({
      type: 'error',
      title: t('Please enter valid phone number'),
    });
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  setTimer = () => {
    const {startTime, time} = this.state;
    if (startTime && !time) {
      this.timer = setInterval(() => {
        const time = BLOCK_REQUEST_PWD_TIME - (Date.now() - startTime);
        if (time >= 0) {
          this.setState({time: Math.ceil(time / 1000)})
        } else {
          clearInterval(this.timer);
          this.setState({time: null, startTime: null})
        }
      }, 100);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.fetching !== this.props.fetching
      && prevProps.fetching
      && !this.props.error) {
        this.setTimer();
      }
  }

  onChange = (name, value) => {
    this.setState({[name]: value});
  }

  render() {
    const {fetching, langs, changeLanguage, currentLang, t} = this.props;
    const {phone, password, time} = this.state;

    return (
      <Fragment>
        <Container>
          <TitleContainer>
            <div style={{width:'100px', marginRight:'36px'}}>
              <LadaLogoIcon primaryColor={colors.N500} />
            </div>
            <div>
              <LadaTitle><Trans>LADA</Trans></LadaTitle>
              <PortalTitle><Trans>Dealer Platform</Trans></PortalTitle>
            </div>
          </TitleContainer>
          <StyledForm onSubmit={this.onFormSubmit}>
            <TextField
              name='phone'
              label={t('Phone')}
              placeholder={t('Enter phone')}
              required={true}
              onChange={this.onChange}
              isDisabled={fetching}
              value={phone}
              type='tel'
            />
            <TextField
              name='password'
              label={t('Password')}
              placeholder={t('Enter password')}
              required={true}
              onChange={this.onChange}
              isDisabled={fetching}
              value={password}
              type='password'
            />
            {time ? (
              <TimeMsg>
                {t('Password has been sent', {time})}
              </TimeMsg>
              ) : (
              <Button
                spacing='none'
                appearance='subtle-link'
                onClick={this.onRememberPassowrd}
                isDisabled={fetching}
              >
                <u>{t('Request new password')}</u>
              </Button>
            )}
            <FormFooter>
              <Button type='submit' isDisabled={fetching} isLoading={fetching} appearance='danger'>
                {t('Login')}
              </Button>
            </FormFooter>
          </StyledForm>
        </Container>
        <LangsContainer>
          <ButtonGroup styles={{align:'center'}} appearance='subtle-link'>
            {langs.map(l => (
              <Button
                key={`lang_btn_${l.id}`}
                onClick={() => changeLanguage(l.id)}
              >
                <span style={{color: l.id === currentLang ? '#172B4D' : '#6B778C'}}>{l.title}</span>
              </Button>
            ))}
          </ButtonGroup>
        </LangsContainer>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    fetching: state.auth.fetching,
    error: state.auth.error,
    langs: state.language.data,
    currentLang: state.language.current,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    login: (phone, password) => dispatch(AuthActions.loginRequest(phone, password)),
    remember: phone => dispatch(AuthActions.rememberPasswordRequest(phone)),
    showPhoneError: msg => dispatch(MessagesActions.messagesShow(msg)),
    changeLanguage: id => dispatch(LanguageActions.languageChangeRequest(id)),
  };
};

export default withTranslation('auth','common')(connect(
  mapStateToProps,
  mapDispatchToProps,
)(LoginPage));
